import { useEffect, useState } from 'react';
import { getPlayerAPI } from '../initSkin';

type PlayerStateField = Extract<keyof PlayerState, string>;

type Callback<T extends PlayerStateField> = (
  payload: Pick<PlayerState, T>
) => void;

// const listenersV1: Map<
//   PlayerStateField[],
//   Set<Callback<PlayerStateField>>
// > = new Map();

interface ICallbackInfo {
  payloadFields: PlayerStateField[];
  callback: Callback<PlayerStateField>;
}

const listenersV2: Map<PlayerStateField, Set<ICallbackInfo>> = new Map();

// export function registerPlayerStateCallbackV1(
//   props: PlayerStateField[],
//   callback: Callback<PlayerStateField>
// ): () => void {
//   let set = listenersV1.get(props);
//   if (!set) {
//     set = new Set();
//     listenersV1.set(props, set);
//   }
//   set.add(callback);

//   return () => {
//     set.delete(callback);
//   };
// }

// export function processPlayerStateCallbacksV1(
//   updatedChunk: Partial<PlayerState>,
//   fullyUpdatedState: PlayerState
// ) {
//   for (const [props, cbs] of listenersV1.entries()) {
//     const payload: Partial<PlayerState> = {};
//     let isNeedToCall = false;
//     for (const prop of props) {
//       if (prop in updatedChunk) {
//         isNeedToCall = true;
//         (payload[prop] as PlayerState[PlayerStateField]) = updatedChunk[prop];
//       } else {
//         (payload[prop] as PlayerState[PlayerStateField]) =
//           fullyUpdatedState[prop];
//       }
//     }

//     if (isNeedToCall) {
//       cbs.forEach((cb) => cb(payload as Pick<PlayerState, PlayerStateField>)); // seems like Promise.resolve has more execution time than direct call
//       // void Promise.resolve().then(() => {
//       // cbs.forEach((cb) => cb(payload as Pick<PlayerState, PlayerStateField>));
//       // });
//     }
//   }
// }

export function registerPlayerStateCallbackV2(
  fields: PlayerStateField[],
  callback: Callback<PlayerStateField>
): () => void {
  const cbInfo: ICallbackInfo = {
    payloadFields: fields,
    callback: callback,
  };

  fields.forEach((field) => {
    let set = listenersV2.get(field);
    if (!set) {
      set = new Set();
      listenersV2.set(field, set);
    }
    set.add(cbInfo);
  });

  return () => {
    fields.forEach((field) => {
      const set = listenersV2.get(field);
      if (set) {
        set.delete(cbInfo);
        if (set.size === 0) {
          listenersV2.delete(field);
        }
      }
    });
  };
}

export function processPlayerStateCallbacksV2(
  updatedChunk: Partial<PlayerState>,
  fullyUpdatedState: PlayerState
) {
  let callbacksToCall: Set<ICallbackInfo> | undefined;

  for (const field of Object.keys(updatedChunk)) {
    const cbInfoSet = listenersV2.get(field as PlayerStateField);
    if (cbInfoSet) {
      if (!callbacksToCall) {
        callbacksToCall = new Set();
      }
      cbInfoSet.forEach((cbInfo) => {
        callbacksToCall!.add(cbInfo);
      });
    }
  }

  callbacksToCall?.forEach(({ callback, payloadFields }) => {
    const payload = payloadFields.reduce<Pick<PlayerState, PlayerStateField>>(
      (accum, field) => {
        (accum[field] as PlayerState[PlayerStateField]) =
          fullyUpdatedState[field];

        return accum;
      },
      {} as Pick<PlayerState, PlayerStateField>
    );
    callback(payload); // seems like Promise.resolve has more execution time than direct call
    // void Promise.resolve().then(() => {
    // cb(payload);
    // });
  });
}

export function usePlayerState<T extends PlayerStateField>(
  props: T[]
): Pick<PlayerState, T> {
  const [state, setState] = useState<Pick<PlayerState, T>>(() => {
    const init: Partial<PlayerState> = {};
    const playerState = getPlayerAPI().getState();
    for (const prop of props) {
      init[prop] = playerState[prop];
    }
    return init as Pick<PlayerState, T>;
  });

  useEffect(() => {
    return registerPlayerStateCallbackV2(props, setState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
